const dataGridModel = {
    assessments: "assessments",
    all_assessments: "all_assessments",
    last_assessments: "last_assessments",
    admin_assessments: "admin_assessments",
    word_frequency: "word_frequency"
}

export default dataGridModel